module.exports = __webpack_public_path__ + "static/media/01_Impression.d746f158.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle01/01_Impression.jpg
 ** module id = 136
 ** module chunks = 0
 **/